import Vue from 'vue'

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el, {value}) {
    if (typeof value === 'undefined' || value) {
      el.focus()
    }
  }
})